import {MetadataTracks} from "./MetadataTracks.js";
import {InstrumentTrack} from "./InstrumentTrack.js";
import { GeneralInformation } from "./GeneralInformation.js"
import { TimeSignatureObject } from "./TimeSignatureObject.js"
import { KeyMarking } from "./KeyMarking.js"
import { TempoObject } from "./TempoObject.js"
import {ANNOTATION_SESSION_ENDPOINT} from "../utils/constants";
import { authFetch } from "../utils/authFetch";
// import annotationSheet from './sample.json';

export class AnnotationSheet {
    constructor(raw_data) {
        const annotationSheet = raw_data.data;

        this.sheet_id = annotationSheet.sheet_id;
        this.user_id = annotationSheet.user_id;

        this.general_info = new GeneralInformation(annotationSheet.general_info);
        this.time_signatures = [];
        for (const timeSignature of annotationSheet.time_signatures) {
            this.time_signatures.push(new TimeSignatureObject(timeSignature));
        }
        this.keys = [];
        for (const key of annotationSheet.keys) {
            this.keys.push(new KeyMarking(key));
        }
        this.tempos = [];
        for (const tempo of annotationSheet.tempos) {
            this.tempos.push(new TempoObject(tempo));
        }
        this.labeling_system = annotationSheet.labeling_system;
        this.metadata_tracks = new MetadataTracks(annotationSheet.metadata_tracks);
        this.instrument_tracks = [];
        for (const instrumentTrack of annotationSheet.instrument_tracks) {
            this.instrument_tracks.push(new InstrumentTrack(instrumentTrack));
        }
        this.updated = false;
    }

    static async loadSheet(userId, sheetId, sessionId) {
        // console.log('Loading sheet...');
        
        // it contains fields: sheet_id, user_id, data (our sheet defn), updatedAt
        const rawAnnotationSheet = await AnnotationSheet.fetchSheet(sheetId, userId, sessionId);
        // console.log("Loaded AnnotationSheet: ", rawAnnotationSheet);
        // extract the data field to be processed by ctor
        return new AnnotationSheet(rawAnnotationSheet);
    }

    static async fetchSheet(sheet_id, user_id, session_id) {
        // Real AWS call
        // console.log('Fetching from AWS...');
        const url = `${ANNOTATION_SESSION_ENDPOINT}/getAnnotationSheet?user_id=${user_id}&sheet_id=${sheet_id}&session_id=${session_id}`;
        const response = await authFetch(url);
        if (!response.ok) throw new Error(`Sheet fetch failed: ${await response.text()}`);
        return await response.json();
    }

    async saveSheet(autosave, user_id, sheet_id, session_id, status) {
        // not easy to maintain sheet_id directly parsed from
        // console.log('AnnotationSheet.save() called with user_id: ', user_id, ", for sheet_id: ", sheet_id);
        
        // // Add a clearer complete object log
        // console.log('SAVE - Complete Object Structure:');
        // const simplifiedObject = {
        //     metadata_tracks: this.metadata_tracks ? {
        //         music_structure_track: this.metadata_tracks.music_structure_track ? 
        //             this.metadata_tracks.music_structure_track.map(block => ({
        //                 section_name: block.section_name,
        //                 block_position: {
        //                     start_time: {
        //                         bar: block.block_position.start_time.bar,
        //                         beat: block.block_position.start_time.beat,
        //                         subdivision: block.block_position.start_time.subdivision
        //                     },
        //                     end_time: {
        //                         bar: block.block_position.end_time.bar,
        //                         beat: block.block_position.end_time.beat,
        //                         subdivision: block.block_position.end_time.subdivision
        //                     }
        //                 }
        //             })) : 'No music structure blocks',
        //         chord_track: this.metadata_tracks.chord_track ? {
        //             chords: this.metadata_tracks.chord_track.chords ? 
        //                 this.metadata_tracks.chord_track.chords.map(block => ({
        //                     chord_info: `${block.chord_degree?.sharp_flat || ''}${block.chord_degree?.note || 'C'} ${block.chord_type || 'Major'}`,
        //                     block_position: {
        //                         start_time: {
        //                             bar: block.block_position.start_time.bar,
        //                             beat: block.block_position.start_time.beat,
        //                             subdivision: block.block_position.start_time.subdivision
        //                         },
        //                         end_time: {
        //                             bar: block.block_position.end_time.bar,
        //                             beat: block.block_position.end_time.beat,
        //                             subdivision: block.block_position.end_time.subdivision
        //                         }
        //                     }
        //                 })) : 'No chord blocks'
        //         } : 'No chord track'
        //     } : 'No metadata tracks',
        //     instrument_tracks: this.instrument_tracks ? 
        //         this.instrument_tracks.map(track => ({
        //             track_id: track.track_id,
        //             instrument: track.instrument,
        //             is_main_melody: track.is_main_melody,
        //             annotation_blocks: track.annotation_blocks ? 
        //                 track.annotation_blocks.map(block => ({
        //                     instrument_function: block.instrument_function,
        //                     block_position: {
        //                         start_time: {
        //                             bar: block.block_position.start_time.bar,
        //                             beat: block.block_position.start_time.beat,
        //                             subdivision: block.block_position.start_time.subdivision
        //                         },
        //                         end_time: {
        //                             bar: block.block_position.end_time.bar,
        //                             beat: block.block_position.end_time.beat,
        //                             subdivision: block.block_position.end_time.subdivision
        //                         }
        //                     }
        //                 })) : 'No annotation blocks'
        //         })) : 'No instrument tracks'
        // };
        // console.log(JSON.stringify(simplifiedObject, null, 2));
        
        // // Original verification logic
        // // Verify Music Structure track data
        // if (this.metadata_tracks && this.metadata_tracks.music_structure_track) {
        //     console.log('SAVE - Verifying Music Structure blocks:');
        //     this.metadata_tracks.music_structure_track.forEach((block, index) => {
        //         console.log(`Block ${index}:`, {
        //             name: block.section_name,
        //             start_time: {
        //                 bar: block.block_position.start_time.bar,
        //                 beat: block.block_position.start_time.beat,
        //                 subdivision: block.block_position.start_time.subdivision
        //             },
        //             end_time: {
        //                 bar: block.block_position.end_time.bar,
        //                 beat: block.block_position.end_time.beat,
        //                 subdivision: block.block_position.end_time.subdivision
        //             }
        //         });
        //     });
        // }
        
        // // Verify Instrument track data
        // if (this.instrument_tracks) {
        //     console.log('SAVE - Verifying Instrument tracks:');
        //     this.instrument_tracks.forEach((track, trackIndex) => {
        //         console.log(`Track ${trackIndex} (${track.track_id}):`);
        //         if (track.annotation_blocks) {
        //             track.annotation_blocks.forEach((block, blockIndex) => {
        //                 console.log(`  Block ${blockIndex}:`, {
        //                     start_time: {
        //                         bar: block.block_position.start_time.bar,
        //                         beat: block.block_position.start_time.beat,
        //                         subdivision: block.block_position.start_time.subdivision
        //                     },
        //                     end_time: {
        //                         bar: block.block_position.end_time.bar,
        //                         beat: block.block_position.end_time.beat,
        //                         subdivision: block.block_position.end_time.subdivision
        //                     }
        //                 });
        //             });
        //         }
        //     });
        // }

        // make sure actually changed
        // console.log('updated flag before save: ', this.updated);

        if (!this.updated && !status) return;

        // do not update original + displayed filename, file path
        try {
            const { data: { general_info: savedInfo } } = await AnnotationSheet.fetchSheet(sheet_id, user_id, session_id);
            this.general_info.displayed_filename = savedInfo.displayed_filename;
            this.general_info.original_filename = savedInfo.original_filename;
            this.general_info.file_path = savedInfo.file_path;
        } catch (error) {
            console.error("Failed to preserve filename data:", error);
        }

        const url = `${ANNOTATION_SESSION_ENDPOINT}/saveAnnotationSheet`;
        const response = await authFetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                data: this,
                user_id: user_id,
                sheet_id: sheet_id,
                session_id: session_id,
                ...(status ? {status} : {})
            })
        });
        if (!response.ok) throw new Error(`HTTP error: ${await response.text()}`);
        // reset updated
        this.updated = false;
    }

    validate() {
        // call subclass's validate
    }
}
